Fundu.Pages.CompanyRegistration = (function($, nv) {

    // Properties
    ///////////////////////////
    var _boardMember = false;
    var _addBoardMemberButton = false;
    var _addBeneficiaryButton = false;
    var _removeBoardMemberButton = false;
    var _removeBeneficiaryButton = false;

    var _boardMemberCount = false;
    var _beneficiaryCount = false;

    var _reportSection = false;
    var _boardMemberSection = false;
    var _beneficiarySection = false;
    var _politicallyActiveSection = false;

    var _name = false;
    var _businessId = false;
    var _registrationDate = false;
    var _registerOfficial = false;
    var _industry = false;
    var _email = false;
    var _iban = false;
    var _inFinancialSupervisionRegister = false;

    var _spokespersonName = false;
    var _spokespersonId = false;

    var _operationReport = false;
    var _scopeReport = false;
    var _economicalStanding = false;
    var _groundsForFundu = false;
    var _investmentFundsOrigin = false;

    var _politicallyInfluentialMember = false;

    var _infoAccepted = false;

    var _userConfirmation = false;

    var _beneficiaryHelpIcon = false;
    var _politicalInfluenceHelpIcon = false;

    var _registrationSaveBtn = false;

    // Private Methods
    ///////////////////////////
    var selectElements = function() {
        _boardMember = $('#boardMember');
        _addBoardMemberButton = $('#addBoardMember');
        _addBeneficiaryButton = $('#addBeneficiary');
        _removeBoardMemberButton = $('#removeBoardMember');;
        _removeBeneficiaryButton = $('#removeBeneficiary');;

        _boardMemberCount = 0;
        _beneficiaryCount = 0;

        _reportSection = $('.third');
        _boardMemberSection = $('.fourth');
        _beneficiarySection = $('.fifth');
        _politicallyActiveSection = $('.sixth');

        _name = $('#name');
        _businessId = $('#businessId');
        _registrationDate = $('#registrationDay_0, #registrationMonth_0, #registrationYear_0');
        _registerOfficial = $('#registerOfficial');
        _industry = $('#industry');
        _email = $('#email');
        _iban = $('#iban');
        _inFinancialSupervisionRegister = $('input[name=inFinancialSupervisionRegister]');

        _spokespersonName = $('#spokespersonName');
        _spokespersonId = $('#spokespersonId');

        _operationReport = $('#operationReport');
        _scopeReport = $('#scopeReport');
        _economicalStanding = $('#economicalStanding');
        _groundsForFundu = $('#groundsForFundu');
        _investmentFundsOrigin = $('#investmentFundsOrigin');

        _politicallyInfluentialMember = $('input[name=politicallyInfluentialMember]');

        _infoAccepted = $('#infoAccepted');

        _userConfirmation = $('#userConfirmation');

        _beneficiaryHelpIcon = $('#beneficiaryHelpIcon');
        _politicalInfluenceHelpIcon = $('#politicalInfluenceHelpIcon');

        _registrationSaveBtn = $('#registrationSaveBtn')
    }

    var initializeComponents = function(){
        _addBoardMemberButton.on('click', function() {
            _boardMemberCount = addInputRow("boardMember_", _boardMemberCount);
        });
        _addBeneficiaryButton.on('click', function() {
            _beneficiaryCount = addInputRow("beneficiary_", _beneficiaryCount);
        });

        _removeBoardMemberButton.on('click', function() {
            _boardMemberCount = removeInputRow("boardMember_", _boardMemberCount);
        });
        _removeBeneficiaryButton.on('click', function() {
            _beneficiaryCount = removeInputRow("beneficiary_", _beneficiaryCount);
        });

        _registrationSaveBtn.on('click', function() { updateCompany(); });
        _inFinancialSupervisionRegister.on('change', toggleRegisterData);
    }

    var addInputRow = function(id, count) {
        if (count < 20) {
            var lastInputRow = $('#' + id + count);
            var newInputRow = lastInputRow.clone(true);

            newInputRow.attr('id', id + (count + 1));

            $.each(newInputRow.find('input'), function (index, elem) {
                resetRowElement(elem, count);
            });

            $.each(newInputRow.find('select'), function (index, elem) {
                resetRowElement(elem, count);
            });

            $.each(newInputRow.find('label'), function (index, elem) {
                var element = $(elem);

                element.attr('for', element.prop('for').replace(count, (count + 1)))
            });

            $.each(newInputRow.find('option'), function (index, elem) {
                var element = $(elem);
                var hidden = element.attr('hidden');


                if (typeof hidden === typeof undefined || hidden === false) {
                    element.removeAttr("selected");
                } else {
                    element.attr("selected");
                }
            });

            newInputRow.insertAfter(lastInputRow);

            count = count + 1;
        }

        return count;
    }

    var resetRowElement = function(elem, count) {
        var element = $(elem);

        element.attr('id', element.prop('id').replace(count, (count + 1)))
        element.val('');
    }

    var removeInputRow = function(id, count) {
        if (count > 0) {
            var lastInputRow = $('#' + id + count);

            lastInputRow.remove();

            count = count - 1;
        }

        return count;
    }

    var toggleRegisterData = function() {

        if (this.value === "1") {
            _reportSection.addClass('hidden');
            _boardMemberSection.addClass('hidden');
            _beneficiarySection.addClass('hidden');
            _politicallyActiveSection.addClass('hidden');
        } else {
            _reportSection.removeClass('hidden');
            _boardMemberSection.removeClass('hidden');
            _beneficiarySection.removeClass('hidden');
            _politicallyActiveSection.removeClass('hidden');
        }
    }

    var initializeHelpButtons = function() {
        _beneficiaryHelpIcon.on('click', function() {
            showBeneficiaryHelpGuard();
        });

        _politicalInfluenceHelpIcon.on('click', function() {
            showPoliticalInfluenceHelpGuard();
        });
    }

    var showBeneficiaryHelpGuard = function() {
        var modelContent = $("<div></div>");

        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.meaning")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text("1) " + Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.meaning1")));
        modelContent.append($("<p></p>").text("2) " + Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.meaning2")));
        modelContent.append($("<p></p>").text("3) " + Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.meaning3")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.ownership")));
        modelContent.append($("<br/>"));
        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.indirect")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text("1) " + Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.indirect1")));
        modelContent.append($("<p></p>").text("2) " + Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.indirect2")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.registration.company.beneficiary.help.identification")));

        Fundu.Helpers.Modal.setModalContent("common.registration.company.beneficiary.help.header", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.continue", callback: function () { Fundu.Helpers.Modal.closeModal(); }},
        ]);
        Fundu.Helpers.Modal.showModal();
    }

    var showPoliticalInfluenceHelpGuard = function() {
        var modelContent = $("<div></div>");

        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text("a) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning1")));
        modelContent.append($("<p></p>").text("b) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning2")));
        modelContent.append($("<p></p>").text("c) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning3")));
        modelContent.append($("<p></p>").text("d) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning4")));
        modelContent.append($("<p></p>").text("e) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning5")));
        modelContent.append($("<p></p>").text("f) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning6")));
        modelContent.append($("<p></p>").text("g) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning7")));
        modelContent.append($("<p></p>").text("h) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning8")));
        modelContent.append($("<p></p>").text("i) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning9")));
        modelContent.append($("<p></p>").text("j) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.meaning10")));
        modelContent.append($("<br/>"));
        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.family")));
        modelContent.append($("<p></p>").text("a) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.family1")));
        modelContent.append($("<p></p>").text("b) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.family2")));
        modelContent.append($("<p></p>").text("c) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.family3")));
        modelContent.append($("<br/>"));
        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.partner")));
        modelContent.append($("<p></p>").text("a) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.partner1")));
        modelContent.append($("<p></p>").text("b) " + Fundu.Helpers.Notify.translate("common.registration.company.political-influence.help.partner2")));

        Fundu.Helpers.Modal.setModalContent("common.registration.company.political-influence.help.header", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.continue", callback: function () { Fundu.Helpers.Modal.closeModal(); }},
        ]);
        Fundu.Helpers.Modal.showModal();
    }


    var getData = function() {

        var inFinancialSupervisionRegister = _inFinancialSupervisionRegister.filter(':checked').val() === "1";

        return {
            name: _name.val(),
            businessId: _businessId.val(),
            registrationDate: Fundu.Components.DatePicker.getDate("registration", 0),
            registerOfficial: _registerOfficial.val(),
            industry: _industry.val(),
            email: _email.val(),
            iban: _iban.val(),
            inFinancialSupervisionRegister: inFinancialSupervisionRegister,

            operationReport: !inFinancialSupervisionRegister ?_operationReport.val() : "-",
            scopeReport: !inFinancialSupervisionRegister ? _scopeReport.val() : "-",
            economicalStanding: !inFinancialSupervisionRegister ? _economicalStanding.val() : "-",
            groundsForFundu: !inFinancialSupervisionRegister ? _groundsForFundu.val() : "-",
            investmentFundsOrigin: !inFinancialSupervisionRegister ? _investmentFundsOrigin.val() : "-",

            boardMembers: !inFinancialSupervisionRegister ? getBoardMembers() : [],

            beneficiaries: !inFinancialSupervisionRegister ? getBeneficiaries() : [],

            politicallyInfluentialMember: _politicallyInfluentialMember.filter(':checked').val() === "1",

            infoAccepted: _infoAccepted.is(':checked'),

            userConfirmation: _userConfirmation.is(':checked')

        };
    }

    var getBoardMembers = function() {
        var boardMembers = [];

        for (var i = 0; i <= _boardMemberCount; i++) {
            boardMembers.push({
                name: $('#boardName_' + i).val(),
                nationality: $('#boardNationality_' + i).val(),
                birthDate: Fundu.Components.DatePicker.getDate("boardBirth", i)
            });
        }

        return boardMembers;
    }

    var getBeneficiaries = function() {
        var beneficiaries = [];

        for (var i = 0; i <= _beneficiaryCount; i++) {
            beneficiaries.push({
                name: $('#beneficiaryName_' + i).val(),
                ssn: $('#beneficiarySsn_' + i).val(),
                birthDate: Fundu.Components.DatePicker.getDate("beneficiaryBirth", i)
            });
        }

        return beneficiaries;
    }

    var resetErrors = function() {
        $('.error').removeClass("error");
        Fundu.Helpers.Notify.hide();
    }

    var displayCompanyErrors = function(errorFields) {

        var displayCompanyErrorCode = null;

        if (errorFields.indexOf("name") >= 0) {
            _name.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "name"; }
        }
        if (errorFields.indexOf("businessId") >= 0) {
            _businessId.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "businessId"; }
        }
        if (errorFields.indexOf("registrationDate") >= 0) {
            _registrationDate.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "registrationDate"; }
        }
        if (errorFields.indexOf("registerOfficial") >= 0) {
            _registerOfficial.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "registerOfficial"; }
        }
        if (errorFields.indexOf("industry") >= 0) {
            _industry.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "industry"; }
        }
        if (errorFields.indexOf("email") >= 0) {
            _email.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "email"; }
        }
        if (errorFields.indexOf("iban") >= 0) {
            _iban.addClass("error");
            if (!displayCompanyErrorCode) { displayCompanyErrorCode = "iban"; }
        }

        if (displayCompanyErrorCode) {
            Fundu.Helpers.Notify.error("company", "error.registration.company." + displayCompanyErrorCode, false, 30000);
        }
    }

    var displayReportErrors = function(errorFields) {

        var displayReportErrorCode = null;

        if (errorFields.indexOf("operationReport") >= 0) {
            _operationReport.addClass("error");
            if (!displayReportErrorCode) { displayReportErrorCode = "operationReport"; }
        }
        if (errorFields.indexOf("scopeReport") >= 0) {
            _scopeReport.addClass("error");
            if (!displayReportErrorCode) { displayReportErrorCode = "scopeReport"; }
        }
        if (errorFields.indexOf("economicalStanding") >= 0) {
            _economicalStanding.addClass("error");
            if (!displayReportErrorCode) { displayReportErrorCode = "economicalStanding"; }
        }
        if (errorFields.indexOf("groundsForFundu") >= 0) {
            _groundsForFundu.addClass("error");
            if (!displayReportErrorCode) { displayReportErrorCode = "groundsForFundu"; }
        }
        if (errorFields.indexOf("investmentFundsOrigin") >= 0) {
            _investmentFundsOrigin.addClass("error");
            if (!displayReportErrorCode) { displayReportErrorCode = "investmentFundsOrigin"; }
        }

        if (displayReportErrorCode) {
            Fundu.Helpers.Notify.error("report", "error.registration.company." + displayReportErrorCode, false, 30000);
        }
    }

    var displayBoardMemberErrors = function(errorFields) {

        var displayBoardMemberErrorCode = null;

        var boardMemberErrors = errorFields.filter(function (propertyName) {
            return propertyName.indexOf("boardMembers") === 0;
        });

        if (boardMemberErrors.length > 0) {

            for (var i = 0; i < boardMemberErrors.length; i++) {

                var error = boardMemberErrors[i];

                var number = error.match(/\d+/)[0];
                var errorField = error.substr(error.lastIndexOf('.') + 1);

                if (errorField === "name") {
                    $('#boardName_' + number).addClass("error");
                    if (!displayBoardMemberErrorCode) { displayBoardMemberErrorCode = "name"; }
                }

                if (errorField === "nationality") {
                    $('#boardNationality_' + number).addClass("error");
                    if (!displayBoardMemberErrorCode) { displayBoardMemberErrorCode = "nationality"; }
                }

                if (errorField === "birthDate") {
                    $('#boardBirthDay_' + number).addClass("error");
                    $('#boardBirthMonth_' + number).addClass("error");
                    $('#boardBirthYear_' + number).addClass("error");
                    if (!displayBoardMemberErrorCode) { displayBoardMemberErrorCode = "birthDate"; }
                }
            }
        }

        if (displayBoardMemberErrorCode) {
            Fundu.Helpers.Notify.error("board", "error.registration.company.board." + displayBoardMemberErrorCode, false, 30000);
        }
    }

    var displayBeneficiaryErrors = function(errorFields) {

        var displayBeneficiaryErrorCode = null;

        var beneficiaryErrors = errorFields.filter(function (propertyName) {
            return propertyName.indexOf("beneficiaries") === 0;
        });

        if (beneficiaryErrors.length > 0) {

            for (var i = 0; i < beneficiaryErrors.length; i++) {

                var error = beneficiaryErrors[i];

                var number = error.match(/\d+/)[0];
                var errorField = error.substr(error.lastIndexOf('.') + 1);

                if (errorField === "name") {
                    $('#beneficiaryName_' + number).addClass("error");
                    if (!displayBeneficiaryErrorCode) { displayBeneficiaryErrorCode = "name"; }
                }

                if (errorField === "ssn") {
                    $('#beneficiarySsn_' + number).addClass("error");
                    if (!displayBeneficiaryErrorCode) { displayBeneficiaryErrorCode = "ssn"; }
                }

                if (errorField === "birthDate") {
                    $('#beneficiaryBirthDay_' + number).addClass("error");
                    $('#beneficiaryBirthMonth_' + number).addClass("error");
                    $('#beneficiaryBirthYear_' + number).addClass("error");
                    if (!displayBeneficiaryErrorCode) { displayBeneficiaryErrorCode = "birthDate"}
                }
            }
        }

        if (displayBeneficiaryErrorCode) {
            Fundu.Helpers.Notify.error("beneficiary", "error.registration.company.beneficiary." + displayBeneficiaryErrorCode, false, 30000);
        }
    }

    var displayAcceptanceErrors = function(errorFields) {

        var displayAcceptanceErrorCode = null;

        if (errorFields.indexOf("infoAccepted") >= 0) {
            if (!displayAcceptanceErrorCode) { displayAcceptanceErrorCode = "infoAccepted"; }
        }
        if (errorFields.indexOf("userConfirmation") >= 0) {
            if (!displayAcceptanceErrorCode) { displayAcceptanceErrorCode = "userConfirmation"; }
        }

        if (displayAcceptanceErrorCode) {
            Fundu.Helpers.Notify.error("infoAccepted", "error.registration.company." + displayAcceptanceErrorCode, false, 30000);
        }
    }

    var showRegistrationSuccessGuard = function() {
        var modelContent = $("<div></div>");

        modelContent.append($("<h5></h5>").text(Fundu.Helpers.Notify.translate("common.registration.company.success-guard.description")));
        modelContent.append($("<br/>"));
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.registration.company.success-guard.info")));
        modelContent.append($("<br/>"));

        var textContent = $("<p></p>");
        textContent.text(Fundu.Helpers.Notify.translate("common.registration.company.success-guard.notice") + " ");

        var link = $("<a></a>");
        link.attr("href", jsRoutes.controllers.SettingsCtrl.myKycAnswers().url);
        link.text(Fundu.Helpers.Notify.translate("common.registration.company.success-guard.here"));

        modelContent.append(textContent.append(link));

        Fundu.Helpers.Modal.setModalContent("common.registration.company.success-guard.title", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.continue", callback: function () { window.location.replace(jsRoutes.controllers.AccountCtrl.myAccount().url); }},
        ]);
        Fundu.Helpers.Modal.showModal();
    }

    var updateCompany = function(data, onSuccess) {

        var data = getData();

        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.RegistrationCtrl.updateCompany().url
        }).done(function(res) {
            if(res && res.success === true) {
                showRegistrationSuccessGuard();
            } else {
                Fundu.Helpers.Notify.error("global", "error.generic");
            }
        }).fail(function(res) {
            var errors = res.responseJSON.errors;
            var errorFields = Object.keys(errors);

            resetErrors();
            displayCompanyErrors(errorFields);
            displayReportErrors(errorFields);
            displayBoardMemberErrors(errorFields);
            displayBeneficiaryErrors(errorFields);
            displayAcceptanceErrors(errorFields);
        })
    };

    // Init
    ///////////////////////////
    var initialize = function() {
        selectElements();
        initializeComponents();
        initializeHelpButtons();

        // disable form submit on Enter-key press on <input type=text>
        $(document).on('keyup keypress', 'form input[type="text"]', function(e) {
            if(e.which == 13) {
                e.preventDefault();
                return false;
            }
        });

        return $.Deferred().resolve(true);
    }

    var finalize = function() {

    }

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
